import React from "react";

// Single-file React component portfolio (Tailwind CSS assumed available)
// Default export

export default function GaganaPortfolio() {
  return (
    <div className="min-h-screen bg-[linear-gradient(180deg,#0f172a,#071029)] text-slate-100 antialiased">
      <header className="max-w-6xl mx-auto p-6 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-full bg-white/8 backdrop-blur-md flex items-center justify-center ring-1 ring-white/10">
            {/* Put your logo or initials here */}
            <span className="font-bold">GY</span>
          </div>
          <div>
            <h1 className="font-semibold">Gagana Yushan Perera</h1>
            <p className="text-xs text-slate-300">Designer • Frontend Developer • Content Creator</p>
          </div>
        </div>
        <nav className="flex items-center gap-4">
          <a className="text-sm hover:underline" href="#projects">Projects</a>
          <a className="text-sm hover:underline" href="#about">About</a>
          <a className="text-sm hover:underline" href="#contact">Contact</a>
        </nav>
      </header>

      <main className="max-w-6xl mx-auto px-6 pb-20">
        {/* Hero */}
        <section className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
          <div className="md:col-span-2 p-8 rounded-2xl bg-white/6 backdrop-blur-lg border border-white/8 shadow-lg">
            <h2 className="text-3xl md:text-4xl font-bold leading-tight">Hey there! I'm Gagana.
              <span className="text-sky-300"> I design & build beautiful web experiences.</span>
            </h2>
            <p className="mt-4 text-slate-300">Frontend developer and simple designer with experience in UI/UX, React, and product design. Currently working as a Production Asscociate in Web Automation<a href="https://www.bing.com/ck/a?!&&p=9a8b64518039d48d999bb3d6d94689b98bce19043b930e0266a5cebea8051da7JmltdHM9MTc1NzQ2MjQwMA&ptn=3&ver=2&hsh=4&fclid=3ea0572c-4b3d-607a-3ce1-58e94f3d629a&psq=innodata+lanka+pvt+ltd&u=a1aHR0cHM6Ly9say5saW5rZWRpbi5jb20vY29tcGFueS9pbm5vZGF0YWxhbmth"> @Innodata Lanka Pvt Ltd.</a></p>

            <div className="mt-6 flex gap-3">
              <a href="#projects" className="px-4 py-2 rounded-xl border border-white/10">See projects</a>
              <a href="#contact" className="px-4 py-2 rounded-xl border border-white/10">Contact me</a>
              <a href="https://www.chatbase.co/chatbot-iframe/oSgkXRIluyr1LEsXN4bpI" className="px-4 py-2 rounded-xl border border-white/10">More Info</a>
            </div>

            <ul className="mt-6 grid grid-cols-2 gap-2 text-xs text-slate-300">
              <li>University: SLIIT — Current undergraduate</li>
              <li>Roles: Production Associate · iComm & Systems Manager (EFB) · Art Director (AIESEC in SLIIT)</li>
              <li>Skills: React, Tailwind, Figma, basic Python, UI/UX</li>
              <li>Interests: Face recognition, chatbots, animation videos, product design</li>
            </ul>
          </div>

          {/* Portrait / quick contact card */}
          <aside className="p-6 rounded-2xl bg-white/4 backdrop-blur-xl border border-white/6 flex flex-col items-center gap-4">
            <div className="w-40 h-40 rounded-xl overflow-hidden ring-1 ring-white/6 bg-gradient-to-br from-white/6 to-white/3">
              <img src="/Gagana.jpeg" alt="Gagana" className="w-full h-full object-cover" />
            </div>
            <div className="text-center">
              <h3 className="font-semibold">Gagana Yushan Perera</h3>
              <p className="text-xs text-slate-300">UI Designer · Frontend Dev · Product Associate</p>
            </div>

            <div className="w-full grid grid-cols-3 gap-2">
              <a href="https://github.com/GaganaUshan" className="text-xs text-center p-2 rounded-md bg-white/3"><b>GitHub</b></a>
              <a href="https://www.linkedin.com/in/gagana-yushan-9025982aa/" className="text-xs text-center p-2 rounded-md bg-white/3"><b>LinkedIn</b></a>
              <a href="https://www.instagram.com/gagana_yushan/" className="text-xs text-center p-2 rounded-md bg-white/3"><b>Instagram</b></a>
            </div>

            <div className="w-full text-xs text-slate-300 text-center">Based in Sri Lanka • Open to internship opportunities</div>
          </aside>
        </section>

        {/* Projects */}
        <section id="projects" className="mt-12">
          <h3 className="text-2xl font-semibold">Selected Projects</h3>
          <p className="text-sm text-slate-300 mt-2">Projects that showcase UI, frontend work and prototypes.</p>

          <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Project Card */}
            <article className="p-6 rounded-2xl bg-white/4 backdrop-blur-md border border-white/6">
              <h4 className="font-semibold">Study Bridge — Student Migration System</h4>
              <p className="mt-2 text-sm text-slate-300">A comprehensive web system for managing student applications, university & course management, scholarship & visa modules. Built UI prototypes and frontend components.</p>
              <div className="mt-4 text-xs text-slate-300">Tech: React, Tailwind • Role: UI & Frontend</div>
            </article>

            <article className="p-6 rounded-2xl bg-white/4 backdrop-blur-md border border-white/6">
              <h4 className="font-semibold">Anime Recommendation App</h4>
              <p className="mt-2 text-sm text-slate-300">An anime discovery app (prototype + zip shared previously). Focused on search, recommendations and smooth UI with animated transitions.</p>
              <div className="mt-4 text-xs text-slate-300">Tech: React, Python + ML • Role: <b><a href="https://animerecommends.netlify.app/">Web-App (Live)</a></b></div>
            </article>

            <article className="p-6 rounded-2xl bg-white/4 backdrop-blur-md border border-white/6">
              <h4 className="font-semibold">Smart Resume Analyzer</h4>
              <p className="mt-2 text-sm text-slate-300">A web app idea to analyze and improve CVs automatically — parsing, scoring and tailored suggestions.</p>
              <div className="mt-4 text-xs text-slate-300">Tech: Python, React • Role: Web-App</div>
            </article>

            <article className="p-6 rounded-2xl bg-white/4 backdrop-blur-md border border-white/6">
              <h4 className="font-semibold">Property Management System</h4>
              <p className="mt-2 text-sm text-slate-300">Manage the Properties that you own so that you won't miss any</p>
              <div className="mt-4 text-xs text-slate-300">Tech: MERN • Role: Experimental Web-App</div>
            </article>

            <article className="p-6 rounded-2xl bg-white/4 backdrop-blur-md border border-white/6">
              <h4 className="font-semibold"> K-Drama Search App Online</h4>
              <p className="mt-2 text-sm text-slate-300">Search and Watch your favourite K-Drama's without any Advertisement. Powered by Custom Search by Google</p>
              <div className="mt-4 text-xs text-slate-300">Tech: Python, React • Role: Web-App</div>
            </article>

            <article className="p-6 rounded-2xl bg-white/4 backdrop-blur-md border border-white/6">
              <h4 className="font-semibold">Background Remover</h4>
              <p className="mt-2 text-sm text-slate-300">Remove backgrounds from images — aimed for simple UX and fast results.</p>
              <div className="mt-4 text-xs text-slate-300">Tech: Python • Role: Web-App</div>
            </article>

          </div>
        </section>

        {/* Experience / Timeline */}
        <section id="about" className="mt-12">
          <h3 className="text-2xl font-semibold">Experience & Education</h3>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="p-6 rounded-2xl bg-white/4 backdrop-blur-md border border-white/6">
              <h4 className="font-semibold">AIESEC & Student Leadership</h4>
              <p className="mt-2 text-sm text-slate-300">Working as iComm & Systems Manager in Entity Finance Board and serving as a creative team member, Currently the Art Director in AIESEC in SLIIT. Experience in Logistics, Marketing and creative direction.</p>
            </div>

            <div className="p-6 rounded-2xl bg-white/4 backdrop-blur-md border border-white/6">
              <h4 className="font-semibold">Courses & Certifications</h4>
              <ul className="mt-2 text-sm text-slate-300 list-disc list-inside">
                <li>Effective Leadership (HP Life)</li>
                <li>Cisco Academy Certificate in English for IT</li>
                <li>British Council Certificates from Movers to PET</li>
                <li>Azure Physical Infrastructure</li>
                <li>Cisco Academy Certificate for Basic IT</li>
              </ul>
            </div>

            <div className="p-6 rounded-2xl bg-white/4 backdrop-blur-md border border-white/6">
              <h4 className="font-semibold">University</h4>
              <p className="mt-2 text-sm text-slate-300">Currently an undergraduate at SLIIT, pursuing projects and internships in frontend development and design.</p>
            </div>

            <div className="p-6 rounded-2xl bg-white/4 backdrop-blur-md border border-white/6">
              <h4 className="font-semibold">Content & Design</h4>
              <p className="mt-2 text-sm text-slate-300">A content creator and designer — Created visual posts for Instagram, brand assets, and UI/UX prototypes.</p>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section id="contact" className="mt-12 p-6 rounded-2xl bg-white/5 backdrop-blur-lg border border-white/6">
          <h3 className="text-2xl font-semibold">Contact</h3>
          <p className="text-sm text-slate-300 mt-2">Connect with Gagana Yushan.</p>

          <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="p-4 rounded-xl bg-white/3">
              <div className="text-xs text-slate-300">Email</div>
              <div className="font-medium">gaganaperera.info@gmail.com</div>
            </div>

            <div className="p-4 rounded-xl bg-white/3">
              <div className="text-xs text-slate-300">Phone</div>
              <div className="font-medium">+94 77 365 0313</div>
            </div>

            <div className="p-4 rounded-xl bg-white/3">
              <div className="text-xs text-slate-300">Location</div>
              <div className="font-medium">Kaluthara, Sri Lanka</div>
            </div>
          </div>

          <div className="mt-6 flex gap-3">
            <a className="px-4 py-2 rounded-xl border border-white/10"><a href="https://my-react-portfolio-alpha-peach.vercel.app/static/media/Gagana%20Yushan%20Perera.6d7ab1958ebba018e3fe.pdf">Check CV</a></a>
          </div>
        </section>

        <footer className="mt-12 text-center text-xs text-slate-400">Made by <a href="https://www.linkedin.com/in/gagana-yushan-9025982aa/"><b>Gagana Yushan</b></a> • UI inspired by liquid glass aesthetics</footer>
      </main>
    </div>
  );
}
